@if (item) {
  <form [formGroup]="form">
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        <ion-item lines="full">
          <ion-input label="Name" labelPlacement="floating" formControlName="name" (ionBlur)="updateName()"></ion-input>
        </ion-item>
        <ion-item lines="full">
          <ion-input label="Description" labelPlacement="floating" formControlName="description"
          (ionBlur)="updateDescription()"></ion-input>
        </ion-item>
        <ion-grid style="display: flex; flex-flow: column">
          <ion-row>
            @for (container of containers; track container) {
              <ion-col size-xs="4" size-md="2">
                <ion-button class="icon-btn" [ngClass]="{ selected: item.container === container.name }"
                  (click)="setContainer(container.name)" size="large" fill="clear">
                  <ion-thumbnail>
                    <ion-img height="100%" [src]="container.icon"></ion-img>
                  </ion-thumbnail>
                </ion-button>
              </ion-col>
            }
          </ion-row>
        </ion-grid>
        <ion-item lines="full">
          <ion-input [label]="'Netto weight (' + units.kegWeight + ')'" labelPlacement="floating"
          formControlName="nettoWeight" type="number" (ionBlur)="updateNettoWeight()"></ion-input>
        </ion-item>
        <ion-item lines="full">
          <ion-input [label]="'Size (' + units.kegs + ')'" labelPlacement="floating" formControlName="size" type="number"
          (ionBlur)="updateSize()"></ion-input>
        </ion-item>
        <ion-item lines="full">
          <ion-input [label]="'Amout left in keg (' + units.kegs + ')'" labelPlacement="floating" formControlName="amount"
          type="number" (ionBlur)="updateAmount()"></ion-input>
        </ion-item>
        <ion-item lines="full">
          <ion-label>Beverage</ion-label>
          @if (beverage && item.beverageId) {
            <ion-button (click)="openBeer(item.beverageId)"
              fill="solid" color="light" slot="end">
              {{ beverage.name }}
            </ion-button>
          }
          @if (item.beverageId) {
            <ion-button (click)="deleteBeverage()" slot="end" fill="clear" shape="round" color="danger" size="default">
              <ion-icon size="small" slot="icon-only" name="trash-outline">
              </ion-icon>
            </ion-button>
          }
          @if (!item.beverageId && item.id) {
            <ion-button (click)="openBeverageModal()" slot="end" fill="clear" shape="round" color="success" size="default">
              <ion-icon size="small" slot="icon-only" name="add-circle-outline">
              </ion-icon>
            </ion-button>
          }
        </ion-item>
        <ion-item lines="full">
          <ion-label>Tap</ion-label>
          @if (currentTap) {
            <ion-button (click)="openTapChooser()" fill="solid" color="light" slot="end">
              {{ currentTap.name }}
            </ion-button>
            <ion-button (click)="removeTapFromKeg(currentTap)" slot="end" fill="clear" shape="round" color="danger" size="default">
              <ion-icon size="small" slot="icon-only" name="trash-outline">
              </ion-icon>
            </ion-button>
          }
          @if (!currentTap && item.id) {
            <ion-button (click)="openTapChooser()" slot="end" fill="clear" shape="round" color="success" size="default">
              <ion-icon size="small" slot="icon-only" name="add-circle-outline">
              </ion-icon>
            </ion-button>
          }
        </ion-item>
        @if (!!allLocations) {
          <ion-item lines="full">
            <ion-select label="Location" labelPlacement="floating" formControlName="location" interface="popover"
              (ionChange)="updateLocation($event)">
              <ion-select-option value="">Choose location</ion-select-option>
              @for (location of allLocations; track location) {
                <ion-select-option [value]="location.id">
                  {{ location.name }}
                </ion-select-option>
              }
            </ion-select>
          </ion-item>
        }
      </ion-card-content>
    </ion-card>
    <div class="ion-margin-top">
      <ion-text color="medium">
        <h6 style="margin-top:0;">Dates</h6>
      </ion-text>
      <ion-card class="ion-no-margin ion-no-padding">
        <ion-card-content class="ion-no-padding">
          <ion-item lines="full">
            <ion-label>Kegging Date</ion-label>
            @if (tapDate) {
              <ion-datetime-button slot="end" datetime="tapDate"></ion-datetime-button>
            }
            @if (!item.tapDate) {
              <ion-button (click)="setDefaultKegTapDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
              </ion-button>
            }
            @if (item.tapDate) {
              <ion-button (click)="deleteKegTapDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            }
            <ion-modal [keepContentsMounted]="true">
              <ng-template>
                @if (tapDate) {
                  <ion-datetime presentation="date" [value]="tapDate" size="cover" id="tapDate"
                    (ionChange)="setKegTapDate($event)" showDefaultButtons="true">
                    <span slot="title">Keg Date</span>
                  </ion-datetime>
                }
              </ng-template>
            </ion-modal>
          </ion-item>
          <ion-item lines="full">
            <ion-label>Best Before Date</ion-label>
            @if (bestBeforeDate) {
              <ion-datetime-button slot="end" datetime="bestBeforeDate"></ion-datetime-button>
            }
            @if (!item.bestBeforeDate) {
              <ion-button (click)="setDefaultKegBestBeforeDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
              </ion-button>
            }
            @if (item.bestBeforeDate) {
              <ion-button (click)="deleteKegBestBeforeDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            }
            <ion-modal [keepContentsMounted]="true">
              <ng-template>
                @if (bestBeforeDate) {
                  <ion-datetime max="2100-12-31" presentation="date" [value]="bestBeforeDate"
                    size="cover" id="bestBeforeDate" (ionChange)="setKegBestBeforeDate($event)" showDefaultButtons="true">
                    <span slot="title">Best Before Date</span>
                  </ion-datetime>
                }
              </ng-template>
            </ion-modal>
          </ion-item>
          @if (bar.useWashing) {
            <ion-item lines="full">
              <ion-label>Latest cleaning</ion-label>
              @if (cleanDate) {
                <ion-datetime-button slot="end" datetime="cleanDate"></ion-datetime-button>
              }
              @if (!item.cleanDate) {
                <ion-button (click)="setDefaultCleanDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                  <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
                </ion-button>
              }
              @if (item.cleanDate) {
                <ion-button (click)="deleteCleanDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                  <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              }
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  @if (cleanDate) {
                    <ion-datetime max="2100-12-31" presentation="date" [value]="cleanDate" size="cover"
                      id="cleanDate" (ionChange)="setCleanDate($event)" showDefaultButtons="true">
                      <span slot="title">Latest Cleaning Date</span>
                    </ion-datetime>
                  }
                </ng-template>
              </ion-modal>
            </ion-item>
          }
          <ion-item lines="none">
            <ion-label>Conditioning End Date</ion-label>
            @if (conditionDate) {
              <ion-datetime-button slot="end" datetime="conditionDate"></ion-datetime-button>
            }
            @if (!item.conditionDate) {
              <ion-button (click)="setDefaultConditionDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
              </ion-button>
            }
            @if (item.conditionDate) {
              <ion-button (click)="deleteConditionDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            }
            <ion-modal [keepContentsMounted]="true">
              <ng-template>
                @if (conditionDate) {
                  <ion-datetime max="2100-12-31" presentation="date" [value]="conditionDate"
                    size="cover" id="conditionDate" (ionChange)="setConditionDate($event)" showDefaultButtons="true">
                    <span slot="title">Condition End Date</span>
                  </ion-datetime>
                }
              </ng-template>
            </ion-modal>
          </ion-item>
        </ion-card-content>
      </ion-card>
    </div>
    <div class="ion-margin-top">
      <ion-text color="medium">
        <h6 style="margin-top:0;">Notification</h6>
      </ion-text>
      <ion-card class="ion-no-margin ion-no-padding">
        <ion-card-content class="ion-no-padding">
          <ion-item lines="full">
            <ion-label>Notification Date</ion-label>
            @if (notificationDate) {
              <ion-datetime-button slot="end" datetime="notificationDate"></ion-datetime-button>
            }
            @if (!item.notificationDate) {
              <ion-button (click)="setDefaultKegNotificationDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
              </ion-button>
            }
            @if (item.notificationDate) {
              <ion-button (click)="deleteKegNotificationDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            }
            <ion-modal [keepContentsMounted]="true">
              <ng-template>
                @if (notificationDate) {
                  <ion-datetime max="2100-12-31" presentation="date" [value]="notificationDate"
                    size="cover" id="notificationDate" (ionChange)="setKegNotificationDate($event)" showDefaultButtons="true">
                    <span slot="title">Notification Date</span>
                  </ion-datetime>
                }
              </ng-template>
            </ion-modal>
          </ion-item>
          <ion-item lines="none">
            <ion-input [label]="'Notification Message'" labelPlacement="floating" formControlName="notificationMessage"
              type="text" errorText="You need to fill out the message if you set a notification date"
            (ionBlur)="updateNotificationMessage()"></ion-input>
          </ion-item>
        </ion-card-content>
      </ion-card>
    </div>
  </form>
}